import { api } from './base';

import { MutationArg, Pageable } from 'v2/types';
import { GroupPromoCodeForm, PromoCodeFilter, PromoCodeModel, UniquePromoCodeForm } from 'v2/types/PromoCodeModel';
import { SWRKeyPaginationWithExtra, SWRKeyValue } from 'v2/types/swr';
import { exportFile, normalizeSearch, shitFilterMapper } from 'v2/utils';

export const promoCodeService = {
  getPromoCodes([_key, page, limit, filter]: SWRKeyPaginationWithExtra<PromoCodeFilter>): Promise<
    Pageable<PromoCodeModel>
  > {
    return api
      .get('v1/admin/promocode', { searchParams: normalizeSearch({ page, limit, filter: shitFilterMapper(filter) }) })
      .json();
  },

  createPromoCode(
    _key: string,
    { arg }: MutationArg<Omit<PromoCodeModel, 'id' | 'createdBy'>>
  ): Promise<PromoCodeModel> {
    return api.post('v1/admin/promocode', { json: arg }).json();
  },

  createUniquePromoCodesGroup(_key: string, { arg }: MutationArg<UniquePromoCodeForm>): Promise<PromoCodeModel[]> {
    return api.post('v1/admin/promocode/unique-group', { json: arg }).json();
  },

  createPromoCodesGroup(_key: string, { arg }: MutationArg<GroupPromoCodeForm>): Promise<PromoCodeModel[]> {
    return api.post('v1/admin/promocode/group', { json: arg }).json();
  },

  deletePromoCode([_key, promoCodeName]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/promocode/${promoCodeName}/delete`).json();
  },

  exportPromoCodes(_key: string, { arg: groupName }: MutationArg<string>): Promise<void> {
    return api
      .get('v1/admin/promocode/group', { searchParams: { groupName } })
      .blob()
      .then((blob) => exportFile(blob, 'promo_codes'));
  },
};
